module.exports = __webpack_public_path__ + "TRUONGhome-4.68eae439.png";